/**
 * Prepare ThePill New Status
 * @param message The message containing the status update
 * @returns  The updated status object
 */
export const handlePillStatusEvent = (message: any) => {
	// @ToDo: Check Peripheral devices which should be deleted
	return message?.status || {};
};
